import React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Row, RowLabel, RowValueGroup, RowValue, RowError } from "./styles";
import { FormRowProps } from "./types";

export const FormRow: React.FC<FormRowProps> = ({
  label,
  value,
  placeholder,
  error,
  highlighted,
  onClick,
  trailingIcon,
}) => {
  const hasValue = Boolean(value);
  const display = hasValue ? value : (placeholder ?? "");
  const icon = trailingIcon ?? (
    <ChevronRightIcon sx={{ color: "var(--color-text-secondary)" }} />
  );

  return (
    <>
      <Row type="button" $highlighted={highlighted} onClick={onClick}>
        <RowLabel>{label}</RowLabel>
        <RowValueGroup>
          <RowValue $placeholder={!hasValue}>{display}</RowValue>
          {icon}
        </RowValueGroup>
      </Row>
      {error ? <RowError>{error}</RowError> : null}
    </>
  );
};
